import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';

// Services
import { CollectStatusEditService } from '../../service/collect-status-edit/collect-status-edit.service';

@Component({
	selector: 'app-collect-status-edit',
	templateUrl: './collect-status-edit.component.html',
	providers: [
		CollectStatusEditService,
		HttpModule
	]
})
export class CollectStatusEditComponent implements OnInit {

	private token;
	private sub: any;
	public permissoes: any[] = [];
	collectStatusForm: FormGroup;
	ID: string;
	Descricao: string = "";
	padraoStatus: boolean = false;
	efetivaStatus: boolean = false;
	naoCobrancaStatus: boolean = false;
	contaExposicaoStatus: boolean = false;
	bloqueioOrdemStatus: boolean = false;
	UsuarioIDCriacao: string;
	DataCriacao: any;
	Ativo: boolean = false;

	constructor(fb: FormBuilder, private collectStatusEditService: CollectStatusEditService, private router: Router, private route: ActivatedRoute) {
		this.token = localStorage.getItem('yara.token');
		this.collectStatusForm = fb.group({
			'ID': '',
			'Descricao': ['', Validators.compose([Validators.required, Validators.maxLength(60)])],
			'Padrao': '',
			'CobrancaEfetiva': '',
			'NaoCobranca': '',
			'ContaExposicao': '',
			'BloqueioOrdem': '',
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.sub = this.route.params.subscribe(params => {
			this.ID = params['guid'];
			this.collectStatusEditService.loadCollectStatus(this.token, this.ID).subscribe(result => {

				if (!result.Result) {
					this.router.navigateByUrl('/status-cobranca');
					return;
				}

				var updateCollectStatus = result.Result;

				this.collectStatusForm.setValue({
					ID: updateCollectStatus.ID,
					Descricao: updateCollectStatus.Descricao,
					Padrao: updateCollectStatus.Padrao,
					CobrancaEfetiva: updateCollectStatus.CobrancaEfetiva,
					NaoCobranca: updateCollectStatus.NaoCobranca,
					ContaExposicao: updateCollectStatus.ContaExposicao,
					BloqueioOrdem: updateCollectStatus.BloqueioOrdem,
					Ativo: updateCollectStatus.Ativo
				});

				this.padraoStatus = updateCollectStatus.Padrao;
				this.efetivaStatus = updateCollectStatus.CobrancaEfetiva;
				this.naoCobrancaStatus = updateCollectStatus.NaoCobranca;
				this.contaExposicaoStatus = updateCollectStatus.ContaExposicao;
				this.bloqueioOrdemStatus = updateCollectStatus.BloqueioOrdem;
				this.Ativo = updateCollectStatus.Ativo;
				
			})
		}, error => {
			console.log(error);
		});
	}

	editCollectStatus(value: any) {
		console.log(value);
		this.collectStatusEditService.editCollectStatus(this.token, value).subscribe(result => {
			if (result.Success)
				this.router.navigateByUrl('/status-cobranca');
		}, error => {
			console.log(error);
		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/status-cobranca');
	}

}



// WEBPACK FOOTER //
// ./src/app/collect-status/component/collect-status-edit/collect-status-edit.component.ts